<template>
    <div class="home-page">
        <el-container>
            <el-header class="header">
                <router-link
                    to="/home"
                    style="
                        color: #67c23a;
                        font-weight: bolder;
                        font-size: 30px;
                        background: linear-gradient(to right, #67c23a, #49a54d);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    "
                    >ALPHA-CEX</router-link
                >
                <div class="profile">
                    <a class="link" @click="refreshAuth()">权限刷新</a>
                    &nbsp;&nbsp;&nbsp;
                    <el-dropdown trigger="click">
                        <span class="el-dropdown-link">
                            {{ this.userInfo.userName
                            }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <a @click="logout">退出</a>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
            </el-header>
            <el-container>
                <el-aside class="aside" width="230px" v-if="isBlockedDate">
                    <el-menu
                        :router="true"
                        background-color="#545c64"
                        text-color="#fff"
                        active-text-color="#ffd04b"
                    >
                        <el-submenu
                            index="user"
                            v-if="
                                rightsContains('APPROVE_KYC') ||
                                rightsContains('APPROVE_KYC_QUERY') ||
                                rightsContains('USER_IDENTITY_INFO') ||
                                rightsContains('USER_TASK_INFO') ||
                                rightsContains('USER_TAG_INFO') ||
                                rightsContains('PROJECT_MANAGE') ||
                                rightsContains('MERCHANT_MAINTAIN') ||
                                rightsContains('APPROVE_TRIBE_INFO') ||
                                rightsContains('WORK_ORDER_USER_LOGIN') ||
                                rightsContains('WORK_ORDER_USER_NO_LOGIN') ||
                                rightsContains('USER_IDENTITY_QUERY') ||
                                rightsContains('PROJECT_BALANCE') ||
                                rightsContains('USER_MSG_ALTER') ||
                                rightsContains('SYSTEM_SITE_CONFIG') ||
                                rightsContains('USER_BALANCE_SNAPSHOT') ||
                                rightsContains('WORK_ORDER_EN_OPERATE') ||
                                rightsContains('WORK_ORDER_EN_DEVELOP')
                            "
                        >
                            <template slot="title">
                                <i class="el-icon-edit-outline"></i>
                                <span slot="title">用户系统</span>
                            </template>
                            <!--              <el-menu-item-->
                            <!--                index="/home/audit/realnameSwitch"-->
                            <!--                v-if="rightsContains('LOGIN_REGIST_AUTH')"-->
                            <!--                >登录注册实名开关</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/audit/kycset"-->
                            <!--                v-if="rightsContains('APPROVE_KYC_CONFIG')"-->
                            <!--                >KYC基础配置</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/home/audit/kyc"
                                v-if="
                                    rightsContains('APPROVE_KYC') ||
                                    rightsContains('APPROVE_KYC_QUERY')
                                "
                                >KYC认证审批</el-menu-item
                            >
                            <el-menu-item
                                index="/home/user/userstatus"
                                v-if="
                                    rightsContains('USER_IDENTITY_INFO') ||
                                    rightsContains('USER_IDENTITY_QUERY')
                                "
                                >用户身份信息</el-menu-item
                            >
                            <el-menu-item
                                index="/home/user/usersub"
                                v-if="
                                    rightsContains('USER_SUB_INFO') ||
                                    rightsContains('USER_SUB_QUERY')
                                "
                                >子账号信息</el-menu-item
                            >
                            <el-menu-item
                                index="/home/user/userMsg/edit"
                                v-if="rightsContains('USER_MSG_ALTER')"
                                >用户身份信息修改</el-menu-item
                            >

                            <el-menu-item
                                index="/home/user/tag"
                                v-if="rightsContains('USER_TAG_INFO')"
                                >用户标签信息</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/user/project"-->
                            <!--                v-if="-->
                            <!--                  rightsContains('PROJECT_MANAGE') ||-->
                            <!--                  rightsContains('PROJECT_BALANCE')-->
                            <!--                "-->
                            <!--                >项目方管理</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/merchant"-->
                            <!--                v-if="rightsContains('MERCHANT_MAINTAIN')"-->
                            <!--                >商户设置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/audit/tribe"-->
                            <!--                v-if="rightsContains('APPROVE_TRIBE_INFO')"-->
                            <!--                >部落资料审批</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/ticket/loginUser"-->
                            <!--                v-if="rightsContains('WORK_ORDER_USER_LOGIN')"-->
                            <!--                >登录用户工单</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/ticket/notLoggedInUser"-->
                            <!--                v-if="rightsContains('WORK_ORDER_USER_NO_LOGIN')"-->
                            <!--                >未登录用户工单</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/home/user/UserWithdrawalConfig"
                                v-if="rightsContains('SYSTEM_SITE_CONFIG')"
                                >用户当日提现限额配置</el-menu-item
                            >
                            <el-menu-item
                                index="/home/user/balanceSnapshot"
                                v-if="rightsContains('USER_BALANCE_SNAPSHOT')"
                                >用户余额快照</el-menu-item
                            >
                          <el-menu-item
                              index="/home/user/BindEmailGroup/emailGroup"
                              v-if="rightsContains('EMAIL_USER_GROUP')"
                          >用户分组</el-menu-item
                          >

                            <el-menu-item index="/home/user/comment">币评论</el-menu-item>
                            <!--              <el-menu-item-->
                            <!--                index="/home/ticket/operateUser"-->
                            <!--                v-if="rightsContains('WORK_ORDER_EN_OPERATE')"-->
                            <!--                >运营人员工单</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/ticket/developUser"-->
                            <!--                v-if="rightsContains('WORK_ORDER_EN_DEVELOP')"-->
                            <!--                >研发人员工单</el-menu-item-->
                            <!--              >-->

                            <el-menu-item
                                v-if="rightsContains('USER_TASK_INFO')"
                                index="/home/user/assess"
                                >任务考核数据</el-menu-item
                            >
                        </el-submenu>

                        <el-submenu
                            index="charge"
                            v-if="
                                rightsContains('APPROVE_DEPOSIT') ||
                                rightsContains('APPROVE_DEPOSIT_QUERY') ||
                                rightsContains('SYSTEM_COIN_WITHDRAW_FEE_QUERY') ||
                                rightsContains('APPROVE_LARGE_DEPOSIT') ||
                                rightsContains('APPROVE_WITHDRAW') ||
                                rightsContains('APPROVE_WITHDRAW_QUERY') ||
                                rightsContains('DEPOSIT_MANUAL') ||
                                rightsContains('TX_MAINTAIN') ||
                                rightsContains('SYSTEM_COIN_TYPE_SETTING') ||
                                rightsContains('SYSTEM_COIN_TYPE_INTRODUCE') ||
                                rightsContains('SYSTEM_COIN_REMIND') ||
                                rightsContains('ENTER_ACCOUNT_AUDIT_CONFIG') ||
                                rightsContains('ENTER_ACCOUNT_AUDIT_MANUAL') ||
                                rightsContains('USER_ADDRESS_QUERY') ||
                                rightsContains('USER_ADDRESS_INFO') ||
                                rightsContains('USER_Withdrawal_ADDRESS_INFO') ||
                                rightsContains('CONFIGURATION_OF_RECHARGE_AUTOMATIC_AUDIT')
                            "
                        >
                            <!-- rightsContains('HOT_COIN_CONFIG') || -->
                            <template slot="title">
                                <i class="el-icon-menu"></i>
                                <span slot="title">充提系统</span>
                            </template>
                            <el-menu-item
                                index="/home/audit/deposit"
                                v-if="
                                    rightsContains('APPROVE_DEPOSIT') ||
                                    rightsContains('APPROVE_DEPOSIT_QUERY')
                                "
                                >充值审核</el-menu-item
                            >
                            <el-menu-item
                                index="/home/withdraw"
                                v-if="rightsContains('SYSTEM_COIN_WITHDRAW_FEE_QUERY')"
                                >设置提现手续费</el-menu-item
                            >
                            <el-menu-item
                                index="/home/audit/depositCheck"
                                v-if="rightsContains('APPROVE_LARGE_DEPOSIT')"
                                >大额充值复审</el-menu-item
                            >
                            <el-menu-item
                                index="/home/audit/config"
                                v-if="rightsContains('ENTER_ACCOUNT_AUDIT_CONFIG')"
                                >入账审核配置</el-menu-item
                            >
                            <el-menu-item
                                index="/home/audit/enter/account"
                                v-if="rightsContains('ENTER_ACCOUNT_AUDIT_MANUAL')"
                                >入账人工审核</el-menu-item
                            >
                            <el-menu-item
                                index="/home/audit/withdrawal"
                                v-if="
                                    rightsContains('APPROVE_WITHDRAW') ||
                                    rightsContains('APPROVE_WITHDRAW_QUERY')
                                "
                                >提现审核</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/audit/setting"-->
                            <!--                v-if="-->
                            <!--                  rightsContains('AUTO_APPROVAL_WITHDRAW') -->
                            <!--                "-->
                            <!--                >提现过审配置</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/home/audit/DepositManual"
                                v-if="rightsContains('DEPOSIT_MANUAL')"
                                >手工录入充值</el-menu-item
                            >
                            <el-menu-item
                                index="/home/txRecord"
                                v-if="rightsContains('TX_MAINTAIN')"
                                >TX录入</el-menu-item
                            >
                            <el-menu-item
                                index="/home/setting/currency"
                                v-if="rightsContains('SYSTEM_COIN_TYPE_SETTING')"
                                >币种设置</el-menu-item
                            >
                            <el-menu-item
                                index="/home/audit/statistic"
                                v-if="
                                    rightsContains('APPROVE_DEPOSIT') ||
                                    rightsContains('APPROVE_DEPOSIT_QUERY')
                                "
                                >数据统计</el-menu-item
                            >
                            <el-menu-item
                                index="/home/setting/currencyIntroduction"
                                v-if="rightsContains('SYSTEM_COIN_TYPE_INTRODUCE')"
                                >币种介绍设置</el-menu-item
                            >
                            <el-menu-item
                                index="/home/setting/coinRemind"
                                v-if="rightsContains('SYSTEM_COIN_REMIND')"
                                >提币充币提醒设置</el-menu-item
                            >
                            <el-menu-item
                                index="/home/audit/transferStation"
                                v-if="rightsContains('WITHDRAW_INTERNAL_AUDIT')"
                                >站内提现审批</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/audit/partner/balance/collect"-->
                            <!--                v-if="rightsContains('PARTNER_BALANCE_COLLECT')"-->
                            <!--                >项目方资产汇总</el-menu-item-->
                            <!--              >-->
                            <!-- <el-menu-item index="/home/audit/depositLimit" v-if="rightsContains('DEPOSIT_LIMIT')">充提限制</el-menu-item> -->
                            <el-menu-item index="/home/Limit" v-if="rightsContains('DEPOSIT_LIMIT')"
                                >充提限制</el-menu-item
                            >
                            <el-menu-item
                                index="/home/audit/hotCoin"
                                v-if="rightsContains('HOT_COIN_CONFIG')"
                                >热门币种配置</el-menu-item
                            >

                            <el-menu-item
                                index="/home/user/usercoinaddress"
                                v-if="
                                    rightsContains('USER_ADDRESS_INFO') ||
                                    rightsContains('USER_ADDRESS_QUERY')
                                "
                                >用户充值地址信息</el-menu-item
                            >

                            <el-menu-item
                                index="/home/user/userWithdrawCoinAddress"
                                v-if="rightsContains('USER_Withdrawal_ADDRESS_INFO')"
                                >用户提现地址信息</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/audit/withdrawInfo"-->
                            <!--                v-if="rightsContains('WITHDRAW_CHAIN_PROMPT_CONF')"-->
                            <!--                >提币链信息提示</el-menu-item-->
                            <!--              >-->
                            <!-- <el-menu-item index="/home/audit/automatic" v-if="rightsContains('CONFIGURATION_OF_RECHARGE_AUTOMATIC_AUDIT')"
                >充值自动过审配置</el-menu-item
              > -->
                        </el-submenu>

                        <el-submenu
                            index="finance"
                            v-if="
                                rightsContains('INNER_TRANSFER_UPLOAD') ||
                                rightsContains('TRANSFER_RECORD_QUERY') ||
                                rightsContains('TRANSFER_COIN_SET') ||
                                rightsContains('AIRDROP_SETTING') ||
                                rightsContains('RECONCILIATION_QUERY') ||
                                rightsContains('WALLET_RECONCILIATION') ||
                                rightsContains('RECONCILIATION_CONFIG') ||
                                rightsContains('USER_BILL') ||
                                rightsContains('TRANSFER_RECORD_SHIZHI_QUERY') ||
                                rightsContains('RECONCILIATION_MANUAL') ||
                                rightsContains('HEDGE_BALANCE_BOOK') ||
                                rightsContains('WALLET_QUERY_BALANCE') ||
                                rightsContains('PSI_BONUS_DISTRIBUTE') ||
                                rightsContains('BURNING_PAIR_BOUNS') ||
                                rightsContains('QAIR_BOUNS') ||
                                rightsContains('FINANCIAL_MANAGE_SYSTEM') ||
                                rightsContains('USER_BILL_statistics') ||
                                rightsContains('platform_BILL_statistics') ||
                                rightsContains('DATA_ANALYSIS_ASSET_STATISTICS')
                            "
                        >
                            <template slot="title">
                                <i class="el-icon-sort"></i>
                                <span slot="title">财务系统</span>
                            </template>
                            <el-menu-item
                                index="/home/transfer/all"
                                v-if="rightsContains('INNER_TRANSFER_UPLOAD')"
                                >Excel/钱包户/内部划转</el-menu-item
                            >
                            <el-menu-item
                                index="/home/transfer/query"
                                v-if="rightsContains('TRANSFER_RECORD_QUERY')"
                                >转账记录查询</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/transfer/transferShiZhiQuery"-->
                            <!--                v-if="rightsContains('TRANSFER_RECORD_SHIZHI_QUERY')"-->
                            <!--                >市值账户转账记录查询</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/home/transfer/coin/set"
                                v-if="
                                    rightsContains('TRANSFER_COIN_SET') ||
                                    rightsContains('AIRDROP_COIN_SETTING')
                                "
                                >转账币种配置</el-menu-item
                            >
                            <el-menu-item
                                index="/home/airdrop"
                                v-if="rightsContains('AIRDROP_SETTING')"
                                >空投设置</el-menu-item
                            >
                            <!--以下功能废弃 -->
                            <!--              <el-menu-item
                index="/home/transfer-approval-whitelist"
                v-if="rightsContains('TRANSFER_APPROVAL_WHITELIST')"
                >批量归集白名单</el-menu-item
              >
              <el-menu-item
                index="/home/withdraw-approval-whitelist"
                v-if="rightsContains('WITHDRAW_APPROVAL_WHILELIST')"
                >提现白名单管理</el-menu-item
              >-->
                            <el-menu-item
                                index="/home/check/account/query"
                                v-if="rightsContains('RECONCILIATION_QUERY')"
                                >对账查询</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/check/account/wallet"-->
                            <!--                v-if="rightsContains('WALLET_RECONCILIATION')"-->
                            <!--                >钱包对账管理</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/home/check/account/conf"
                                v-if="rightsContains('RECONCILIATION_CONFIG')"
                                >对账配置</el-menu-item
                            >
                            <el-menu-item
                                index="/home/check/account/manual"
                                v-if="rightsContains('RECONCILIATION_MANUAL')"
                                >手动对账</el-menu-item
                            >
                            <el-menu-item index="/home/userBill" v-if="rightsContains('USER_BILL')"
                                >用户账单</el-menu-item
                            >
                            <el-menu-item
                                index="/dataAnalysis/user/asset/statistics"
                                v-if="rightsContains('DATA_ANALYSIS_ASSET_STATISTICS')"
                                >用户资产统计</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/transfer/psi"-->
                            <!--                v-if="rightsContains('PSI_BONUS_DISTRIBUTE')"-->
                            <!--                >PSI分红</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/transfer/psiSettle"-->
                            <!--                v-if="rightsContains('PSI_PAIR_BONUS')"-->
                            <!--                >PSI分红结算</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/home/wallet/snapshot"
                                v-if="rightsContains('WALLET_QUERY_BALANCE')"
                                >实时生成钱包余额快照</el-menu-item
                            >

                            <!--              <el-menu-item-->
                            <!--                index="/home/transfer/bouns"-->
                            <!--                v-if="rightsContains('QAIR_BOUNS')"-->
                            <!--                >配置代币分红</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/entries/BurnCoinBonus"-->
                            <!--                v-if="rightsContains('BURNING_PAIR_BOUNS')"-->
                            <!--                >燃烧币种分红</el-menu-item-->
                            <!--              >-->

                            <el-menu-item
                                index="/fundDetails/walletbill"
                                v-if="rightsContains('FUND_DETAILS')"
                                >资金明细</el-menu-item
                            >

                            <el-menu-item
                                index="/home/user/userstatistics"
                                v-if="rightsContains('USER_BILL_statistics')"
                                >用户对账查询</el-menu-item
                            >
                            <el-menu-item
                                index="/home/user/statisticsPlatform"
                                v-if="rightsContains('platform_BILL_statistics')"
                                >平台账单查询</el-menu-item
                            >
                        </el-submenu>

                        <!--            <el-submenu-->
                        <!--              index="finance/manage"-->
                        <!--              v-if="-->
                        <!--                rightsContains('SYSTEM_CURRENT_INTEREST') ||-->
                        <!--                rightsContains('PLEDGE_INTEREST_PROJECT') ||-->
                        <!--                rightsContains('MORTGAGE_MANAGE_CONFIG') ||-->
                        <!--                rightsContains('MORTGAGE_MANAGE_ORDER') ||-->
                        <!--                rightsContains('FUND_MANAGEMENT') ||-->
                        <!--                rightsContains('STAKING') ||-->
                        <!--                rightsContains('STAKING_LOCK') ||-->
                        <!--                rightsContains('STAKING_INCOME') ||-->
                        <!--                rightsContains('STAKING_COUNT') ||-->
                        <!--                rightsContains('USER_MINING_RATE') ||-->
                        <!--                rightsContains('USER_MINING_AWARD') ||-->
                        <!--                rightsContains('USER_MINING_CONFIG') ||-->
                        <!--                rightsContains('MINING_REGULAR_CONFIG') ||-->
                        <!--                rightsContains('MINING_REGULAR_ORDER') ||-->
                        <!--                rightsContains('MINING_ALIVE_REGULAR_CONFIG') ||-->
                        <!--                rightsContains('MINING_NEW_COIN_CONFIG')-->
                        <!--              "-->
                        <!--            >-->
                        <!--              <template slot="title">-->
                        <!--                <i class="el-icon-sold-out"></i>-->
                        <!--                <span slot="title">理财系统</span>-->
                        <!--              </template>-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/setting/current"-->
                        <!--                v-if="rightsContains('SYSTEM_CURRENT_INTEREST')"-->
                        <!--                >活期宝设置</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/pledge/interest"-->
                        <!--                v-if="rightsContains('PLEDGE_INTEREST_PROJECT')"-->
                        <!--                >存币生息</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/raiseFunds"-->
                        <!--                v-if="rightsContains('FUND_MANAGEMENT')"-->
                        <!--                >基金管理</el-menu-item-->
                        <!--              >-->

                        <!--              <el-submenu-->
                        <!--                index="/home/finance/manage/mortgage"-->
                        <!--                v-if="-->
                        <!--                  rightsContains('MORTGAGE_MANAGE_CONFIG') ||-->
                        <!--                  rightsContains('MORTGAGE_MANAGE_ORDER')-->
                        <!--                "-->
                        <!--              >-->
                        <!--                <template slot="title">-->
                        <!--                  <span slot="title">借贷宝</span>-->
                        <!--                </template>-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/finance/manage/mortgage/system"-->
                        <!--                  v-if="rightsContains('MORTGAGE_MANAGE_CONFIG')"-->
                        <!--                  >借贷宝系统配置</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/finance/manage/mortgage/coin"-->
                        <!--                  v-if="rightsContains('MORTGAGE_MANAGE_CONFIG')"-->
                        <!--                  >借贷宝币种管理</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/finance/manage/mortgage/precept"-->
                        <!--                  v-if="rightsContains('MORTGAGE_MANAGE_CONFIG')"-->
                        <!--                  >借贷宝方案管理</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/finance/manage/mortgage/account"-->
                        <!--                  v-if="rightsContains('MORTGAGE_MANAGE_ORDER')"-->
                        <!--                  >平台抵押借款账户管理</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/finance/manage/mortgage/orderList"-->
                        <!--                  v-if="rightsContains('MORTGAGE_MANAGE_ORDER')"-->
                        <!--                  >借贷宝订单管理</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/finance/manage/mortgage/alarmManage"-->
                        <!--                  v-if="rightsContains('MORTGAGE_MANAGE_ORDER')"-->
                        <!--                  >借贷宝资产预警统计</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/finance/manage/mortgage/blastList"-->
                        <!--                  v-if="rightsContains('MORTGAGE_MANAGE_ORDER')"-->
                        <!--                  >强平订单管理</el-menu-item-->
                        <!--                >-->
                        <!--              </el-submenu>-->

                        <!--              <el-submenu-->
                        <!--                index="/home/mining/manage"-->
                        <!--                v-if="-->
                        <!--                  rightsContains('USER_MINING_RATE') ||-->
                        <!--                  rightsContains('USER_MINING_AWARD') ||-->
                        <!--                  rightsContains('USER_MINING_CONFIG') ||-->
                        <!--                  rightsContains('MINING_REGULAR_CONFIG') ||-->
                        <!--                  rightsContains('MINING_REGULAR_ORDER') ||-->
                        <!--                  rightsContains('MINING_ALIVE_REGULAR_CONFIG') ||-->
                        <!--                  rightsContains('MINING_NEW_COIN_CONFIG')-->
                        <!--                "-->
                        <!--              >-->
                        <!--                <template slot="title">-->
                        <!--                  <span slot="title">挖矿宝</span>-->
                        <!--                </template>-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/mining/manage/rate"-->
                        <!--                  v-if="rightsContains('USER_MINING_RATE')"-->
                        <!--                  >利率管理</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/mining/manage/award"-->
                        <!--                  v-if="rightsContains('USER_MINING_AWARD')"-->
                        <!--                  >挖矿管理</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/mining/alive"-->
                        <!--                  v-if="rightsContains('MINING_ALIVE_REGULAR_CONFIG')"-->
                        <!--                  >活期挖矿</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/mining/flexible"-->
                        <!--                  v-if="rightsContains('USER_MINING_CONFIG')"-->
                        <!--                  >灵活挖矿</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/mining/regular"-->
                        <!--                  v-if="-->
                        <!--                    rightsContains('MINING_REGULAR_CONFIG') ||-->
                        <!--                    rightsContains('MINING_REGULAR_ORDER')-->
                        <!--                  "-->
                        <!--                  >定期挖矿</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/mining/newCoin"-->
                        <!--                  v-if="rightsContains('MINING_NEW_COIN_CONFIG')"-->
                        <!--                  >新币挖矿</el-menu-item-->
                        <!--                >-->
                        <!--              </el-submenu>-->

                        <!--              <el-submenu-->
                        <!--                index="/home/staking"-->
                        <!--                v-if="-->
                        <!--                  rightsContains('STAKING') ||-->
                        <!--                  rightsContains('STAKING_LOCK') ||-->
                        <!--                  rightsContains('STAKING_INCOME') ||-->
                        <!--                  rightsContains('STAKING_COUNT')-->
                        <!--                "-->
                        <!--              >-->
                        <!--                <template slot="title">-->
                        <!--                  <span slot="title">Staking锁仓挖矿</span>-->
                        <!--                </template>-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/staking/primary/config"-->
                        <!--                  v-if="rightsContains('STAKING')"-->
                        <!--                  >基础配置</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/staking/pair/config"-->
                        <!--                  v-if="rightsContains('STAKING')"-->
                        <!--                  >交易对配置</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/staking/order"-->
                        <!--                  v-if="-->
                        <!--                    rightsContains('STAKING_LOCK') ||-->
                        <!--                    rightsContains('STAKING_UNLOCK')-->
                        <!--                  "-->
                        <!--                  >锁仓/解锁管理</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/staking/incomeDistribution"-->
                        <!--                  v-if="rightsContains('STAKING_INCOME')"-->
                        <!--                  >收益发放</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/home/staking/lockAndUnlock/statistics"-->
                        <!--                  v-if="rightsContains('STAKING_COUNT')"-->
                        <!--                  >锁仓/解锁统计</el-menu-item-->
                        <!--                >-->
                        <!--              </el-submenu>-->
                        <!--            </el-submenu>-->

                        <el-submenu
                            index="trade"
                            v-if="
                                rightsContains('APPROVE_C2C_ORDER') ||
                                rightsContains('SYSTEM_PAIR_SETTING') ||
                                rightsContains('SYSTEM_TRADE_SET_SETTING') ||
                                rightsContains('TRADE_ACTIVITY_SET') ||
                                rightsContains('TRADE_ACTIVITY_QUERY') ||
                                rightsContains('TRADE_PAIR_AVG_COST') ||
                                rightsContains('TRADE_PAIR_ORDER_NUM') ||
                                rightsContains('POSITION_INFO') ||
                                rightsContains('SNAP_POSITION') ||
                                rightsContains('TRADE_EXCEPTION') ||
                                rightsContains('QUOTATION_SYNC_SET') ||
                                rightsContains('BRUSH_CONFIG_SET') ||
                                rightsContains('HEDGE_MANAGE') ||
                                rightsContains('EXPORT_USER_TRADE_DEAL') ||
                                rightsContains('MARKET_MAKER_MANAGE') ||
                                rightsContains('TRADE_WHITELIST') ||
                                rightsContains('MACHINE_STRATEGY_COINFIG') ||
                                rightsContains('SNAPSHOT_STATISTICS')
                            "
                        >
                            <template slot="title">
                                <i class="el-icon-sold-out"></i>
                                <span slot="title">交易系统</span>
                            </template>
                            <!--              <el-menu-item-->
                            <!--                index="/home/audit/c2c"-->
                            <!--                v-if="rightsContains('APPROVE_C2C_ORDER')"-->
                            <!--                >C2C订单审批</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/home/setting/tradePair"
                                v-if="rightsContains('SYSTEM_PAIR_SETTING')"
                                >交易对设置</el-menu-item
                            >
                            <el-menu-item
                                index="/home/setting/trade/range"
                                v-if="rightsContains('SYSTEM_TRADE_SET_SETTING')"
                                >交易区设置</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/setting/pairbonus"-->
                            <!--                v-if="rightsContains('SYSTEM_PAIR_SETTING')"-->
                            <!--                >燃烧代币分红设置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/trade/activity/projects"-->
                            <!--                v-if="rightsContains('TRADE_ACTIVITY_SET')"-->
                            <!--                >交易活动设置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/trade/activity/rank"-->
                            <!--                v-if="rightsContains('TRADE_ACTIVITY_QUERY')"-->
                            <!--                >交易排行榜</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/home/trade/avg/cost"
                                v-if="rightsContains('TRADE_PAIR_AVG_COST')"
                                >交易对平均买入成本</el-menu-item
                            >
                            <el-menu-item
                                index="/home/trade/order/persons"
                                v-if="
                                    rightsContains('TRADE_PAIR_ORDER_NUM') ||
                                    rightsContains('EXPORT_USER_TRADE_DEAL')
                                "
                                >交易对订单数,成交信息</el-menu-item
                            >
                            <el-menu-item
                                index="/home/trade/coin/account"
                                v-if="rightsContains('POSITION_INFO')"
                                >持仓数据</el-menu-item
                            >
                            <el-menu-item
                                index="/home/trade/snap/position"
                                v-if="rightsContains('SNAP_POSITION')"
                                >快照持仓</el-menu-item
                            >
                            <el-menu-item
                                index="/home/trade/exception"
                                v-if="rightsContains('TRADE_EXCEPTION')"
                                >交易异常</el-menu-item
                            >
                            <el-menu-item
                                index="/home/quotation/sync"
                                v-if="
                                    rightsContains('QUOTATION_SYNC_SET') ||
                                    rightsContains('BRUSH_CONFIG_SET')
                                "
                                >行情同步/中间刷量策略</el-menu-item
                            >
                            <el-menu-item
                                index="/home/trade/hedge/manage"
                                v-if="
                                    rightsContains('HEDGE_MANAGE') ||
                                    rightsContains('HEDGE_STRATEGY')
                                "
                                >对冲管理</el-menu-item
                            >
                            <el-menu-item
                                index="/home/hedge/markets/sheet"
                                v-if="
                                    rightsContains('NEW_HEDGE_MANAGE') ||
                                    rightsContains('NEW_HEDGE_STRATEGY')
                                "
                                >新对冲管理</el-menu-item
                            >
                            <el-menu-item
                                index="/home/hedge/balance/book"
                                v-if="rightsContains('HEDGE_BALANCE_BOOK')"
                                >对冲对账明细</el-menu-item
                            >
                            <el-menu-item
                                index="/home/user/market/maker"
                                v-if="rightsContains('MARKET_MAKER_MANAGE')"
                                >做市商管理</el-menu-item
                            >
                            <el-menu-item
                                index="/home/trade-whitelist"
                                v-if="rightsContains('TRADE_WHITELIST')"
                                >交易白名单管理</el-menu-item
                            >
                            <!-- <el-menu-item
                index="/home/traders/policSettings"
                v-if="rightsContains('MACHINE_STRATEGY_COINFIG')"
                >机器人策略设置</el-menu-item
              > -->
                            <el-menu-item
                                index="/home/snapshotStatistic"
                                v-if="rightsContains('SNAPSHOT_STATISTICS')"
                                >交易对成本图表分析</el-menu-item
                            >
                            <!-- <el-menu-item index="/home/machine/switch" v-if="rightsContains('AUTHORITY_SETTING')">机器人开关</el-menu-item>-->
                            <!-- <el-menu-item index="/home/machine/project" v-if="rightsContains('PROJECT_MACHINE_MANAGE')">项目方机器人管理</el-menu-item>-->
                            <!-- <el-menu-item
                index="/home/balance/center/account/reconciliation"
                v-if="rightsContains('HEDGE_BALANCE_RECONCILIATION')"
                >财务对账</el-menu-item
              > -->
                            <el-menu-item
                                index="/home/robot/maintenance"
                                v-if="rightsContains('UPDATE_REDIS_LOCK_CONTROL_UUID')"
                                >更新REDIS分布式锁UUID</el-menu-item
                            >
                            <el-menu-item
                                index="/home/trade/cache"
                                v-if="rightsContains('CACHE_DELETE')"
                                >删除特殊缓存</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/trade/risk/controller"-->
                            <!--                v-if="rightsContains('RISK_CONTROL_WARNING')"-->
                            <!--                >监控警告</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/home/market/delegation/user/distinguish"
                                v-if="rightsContains('MARKET_POSITION_USER_DISTINGUISH')"
                                >盘口做市委托区分</el-menu-item
                            >
                            <!--               <el-menu-item-->
                            <!--                index="/home/userTips"-->
                            <!--                v-if="rightsContains('SYSTEM_PAIR_TIP_SETTING')"-->
                            <!--                >交易对提示配置</el-menu-item-->
                            <!--              >-->

                            <el-submenu
                                index="trade-order"
                                v-if="
                                    rightsContains('trade_order') ||
                                    rightsContains('trade_order_detail')
                                "
                            >
                                <template slot="title">
                                    <i class=""></i>
                                    <span slot="title">委托管理</span>
                                </template>
                                <el-menu-item
                                    index="/home/traders/order"
                                    v-if="rightsContains('trade_order')"
                                    >委托订单</el-menu-item
                                >
                                <el-menu-item
                                    index="/home/traders/orderDetail"
                                    v-if="rightsContains('trade_order_detail')"
                                    >成交明细</el-menu-item
                                >
                            </el-submenu>
                        </el-submenu>

                        <!--            <el-submenu-->
                        <!--              index="etp/system"-->
                        <!--              v-if="-->
                        <!--                rightsContains('ETP_MERGE') ||-->
                        <!--                rightsContains('ETP_COIN_SHOW_CONFIG')-->
                        <!--              "-->
                        <!--            >-->
                        <!--              <template slot="title">-->
                        <!--                <i class="el-icon-sold-out"></i>-->
                        <!--                <span slot="title">ETP业务系统</span>-->
                        <!--              </template>-->
                        <!--              <el-menu-item-->
                        <!--                index="/etp/system/billboard"-->
                        <!--                v-if="rightsContains('ETP_COIN_SHOW_CONFIG')"-->
                        <!--                >榜单管理</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/etp/system/dataOverview"-->
                        <!--                v-if="rightsContains('ETP_COIN_SHOW_CONFIG')"-->
                        <!--                >数据概览</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/etp/system/manageFee"-->
                        <!--                v-if="rightsContains('ETP_COIN_SHOW_CONFIG')"-->
                        <!--                >管理费统计</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/etp/system/serviceFee"-->
                        <!--                v-if="rightsContains('ETP_COIN_SHOW_CONFIG')"-->
                        <!--                >手续费统计</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/etp/system/tradeData"-->
                        <!--                v-if="rightsContains('ETP_COIN_SHOW_CONFIG')"-->
                        <!--                >交易数据统计</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/etp/system/positionData"-->
                        <!--                v-if="rightsContains('ETP_COIN_SHOW_CONFIG')"-->
                        <!--                >持仓数据统计</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/etp/system/profitLossData"-->
                        <!--                v-if="rightsContains('ETP_COIN_SHOW_CONFIG')"-->
                        <!--                >用户盈亏统计</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/etp/system/etpMerge"-->
                        <!--                v-if="rightsContains('ETP_MERGE')"-->
                        <!--                >ETP合并</el-menu-item-->
                        <!--              >-->
                        <!--            </el-submenu>-->

                        <!--            <el-submenu-->
                        <!--              index="otc"-->
                        <!--              v-if="-->
                        <!--                rightsContains('OTC_MERCHANT_APPLY') ||-->
                        <!--                rightsContains('OTC_PAYEE_APPROVE') ||-->
                        <!--                rightsContains('OTC_MERCHANT_UPGRADE') ||-->
                        <!--                rightsContains('OTC_ADVERTISING_APPROVE') ||-->
                        <!--                rightsContains('OTC_ORDER_APPROVE') ||-->
                        <!--                rightsContains('OTC_ORDER_APPEAL') ||-->
                        <!--                rightsContains('OTC_ADVERTISING_COIN') ||-->
                        <!--                rightsContains('OTC_FEE_CONFIG') ||-->
                        <!--                rightsContains('OTC_QUERY_COUNT') ||-->
                        <!--                rightsContains('OTC_MERCHANT_MANAGE')-->
                        <!--              "-->
                        <!--            >-->
                        <!--              <template slot="title">-->
                        <!--                <i class="el-icon-d-caret"></i>-->
                        <!--                <span slot="title">OTC业务系统</span>-->
                        <!--              </template>-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/audit/otc"-->
                        <!--                v-if="-->
                        <!--                  rightsContains('OTC_MERCHANT_APPLY') ||-->
                        <!--                  rightsContains('OTC_PAYEE_APPROVE') ||-->
                        <!--                  rightsContains('OTC_MERCHANT_UPGRADE') ||-->
                        <!--                  rightsContains('OTC_ADVERTISING_APPROVE') ||-->
                        <!--                  rightsContains('OTC_ORDER_APPROVE') ||-->
                        <!--                  rightsContains('OTC_ORDER_APPEAL') ||-->
                        <!--                  rightsContains('OTC_MERCHANT_MANAGE')-->
                        <!--                "-->
                        <!--                >OTC业务</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/setting/otc/advertising"-->
                        <!--                v-if="rightsContains('OTC_ADVERTISING_COIN')"-->
                        <!--                >OTC广告币种配置</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/setting/otc/fee"-->
                        <!--                v-if="rightsContains('OTC_FEE_CONFIG')"-->
                        <!--                >OTC手续费配置</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/setting/otc/statistic"-->
                        <!--                v-if="rightsContains('OTC_QUERY_COUNT')"-->
                        <!--                >OTC出入金统计</el-menu-item-->
                        <!--              >-->
                        <!--            </el-submenu>-->

                        <!--            <el-submenu-->
                        <!--              index="/surperContract"-->
                        <!--              v-if="-->
                        <!--                rightsContains('SYSTEM_SUPER_CONTRACT_ORDER') ||-->
                        <!--                rightsContains('SYSTEM_SUPER_CONTRACT_CONFIG') ||-->
                        <!--                rightsContains('SYSTEM_SUPER_CONTRACT_PROFIT')-->
                        <!--              "-->
                        <!--            >-->
                        <!--              <template slot="title">-->
                        <!--                <i class="el-icon-setting"></i>-->
                        <!--                <span slot="title">超级合约</span>-->
                        <!--              </template>-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/finance/manage/mortgage/userSurvey"-->
                        <!--                v-if="rightsContains('SYSTEM_SUPER_CONTRACT_ORDER')"-->
                        <!--                >佣金情况</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/finance/manage/mortgage/partnerManage"-->
                        <!--                v-if="rightsContains('SYSTEM_SUPER_CONTRACT_CONFIG')"-->
                        <!--                >项目方管理</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/finance/manage/mortgage/transactionHold"-->
                        <!--                v-if="rightsContains('SYSTEM_SUPER_CONTRACT_ORDER')"-->
                        <!--                >交易持仓</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/finance/manage/general/profit"-->
                        <!--                v-if="rightsContains('SYSTEM_SUPER_CONTRACT_PROFIT')"-->
                        <!--                >超级合约盈亏统计</el-menu-item-->
                        <!--              >-->
                        <!--            </el-submenu>-->

                        <!--            <el-submenu-->
                        <!--              index="contractBian"-->
                        <!--              v-if="-->
                        <!--                rightsContains('CONTRACT_SYMBOL_CONFIG') ||-->
                        <!--                rightsContains('CONTRACT_TRANSFER_MANAGE') ||-->
                        <!--                rightsContains('CONTRACT_ORDER_MANAGE')-->
                        <!--              "-->
                        <!--            >-->
                        <!--              <template slot="title">-->
                        <!--                <i class="el-icon-setting"></i>-->
                        <!--                <span slot="title">币安合约</span>-->
                        <!--              </template>-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/contractBian/symbolConfig"-->
                        <!--                v-if="rightsContains('CONTRACT_SYMBOL_CONFIG')"-->
                        <!--                >合约配置</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/contractBian/transferRecord"-->
                        <!--                v-if="rightsContains('CONTRACT_TRANSFER_MANAGE')"-->
                        <!--                >划转记录</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/contractBian/transferStatistics"-->
                        <!--                v-if="-->
                        <!--                  rightsContains('CONTRACT_TRANSFER_MANAGE') ||-->
                        <!--                  rightsContains('CONTRACT_COUNT_MANAGE')-->
                        <!--                "-->
                        <!--                >划转统计</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/contractBian/orderRecord"-->
                        <!--                v-if="rightsContains('CONTRACT_ORDER_MANAGE')"-->
                        <!--                >交易、挂单、订单、强平记录</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/contractBian/userBalance"-->
                        <!--                v-if="rightsContains('CONTRACT_USER_MANAGE')"-->
                        <!--                >用户信息查询</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/contractBian/bnBalance"-->
                        <!--                v-if="-->
                        <!--                  rightsContains('CONTRACT_TRANSFER_MANAGE') ||-->
                        <!--                  rightsContains('CONTRACT_COUNT_MANAGE')-->
                        <!--                "-->
                        <!--                >合约统计</el-menu-item-->
                        <!--              >-->
                        <!--            </el-submenu>-->

                        <!--            <el-submenu-->
                        <!--              index="contractFee"-->
                        <!--              v-if="rightsContains('CONTRACT_FEE_SHARE')"-->
                        <!--            >-->
                        <!--              <template slot="title">-->
                        <!--                <i class="el-icon-setting"></i>-->
                        <!--                <span slot="title">合约手续费</span>-->
                        <!--              </template>-->
                        <!--              <el-menu-item-->
                        <!--                index="/home/contractfee"-->
                        <!--                v-if="rightsContains('CONTRACT_FEE_SHARE')"-->
                        <!--                >合约手续费设置</el-menu-item-->
                        <!--              >-->
                        <!--            </el-submenu>-->

                        <el-submenu
                            index="portal"
                            v-if="
                                rightsContains('SYSTEM_BANNER_SETTING') ||
                                rightsContains('SYSTEM_BANNER_NEW_SETTING') ||
                                rightsContains('SYSTEM_CONTENT_SETTING') ||
                                rightsContains('SYSTEM_POSTER_SETTING') ||
                                rightsContains('AGREEMENT_ENTRY') ||
                                rightsContains('PROMPT') ||
                                rightsContains('APP_COMPONENT') ||
                                rightsContains('APP_KING_KONG') ||
                                rightsContains('FINANCIAL_MANAGEMENT') ||
                                rightsContains('LIST_GAINS_BLANK') ||
                                rightsContains('LIST_POPULAR') ||
                                rightsContains('PLATE_MANAGE') ||
                                rightsContains('FOCUS') ||
                                rightsContains('APP_PRODUCT_CATEGORY') ||
                                rightsContains('APP_PRODUCT_SELECTION') ||
                                rightsContains('APP_PRODUCT_RECOMMEND') ||
                                rightsContains('COMMUNITY_MANAGEMENT')
                            "
                        >
                            <template slot="title">
                                <i class="el-icon-bell"></i>
                                <span slot="title">PORTAL系统</span>
                            </template>
                            <el-menu-item
                                index="/home/setting/bannerNew"
                                v-if="rightsContains('SYSTEM_BANNER_NEW_SETTING')"
                                >Banner设置新版</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/setting/content"-->
                            <!--                v-if="rightsContains('SYSTEM_CONTENT_SETTING')"-->
                            <!--                >内容设置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/setting/poster"-->
                            <!--                v-if="rightsContains('SYSTEM_POSTER_SETTING')"-->
                            <!--                >邀请海报设置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/agreement"-->
                            <!--                v-if="rightsContains('AGREEMENT_ENTRY')"-->
                            <!--                >协议录入</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item index="/home/notice" v-if="rightsContains('PROMPT')"-->
                            <!--                >弹出消息</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/portal/app/home"
                                v-if="
                                    rightsContains('APP_COMPONENT') ||
                                    rightsContains('APP_KING_KONG') ||
                                    rightsContains('FINANCIAL_MANAGEMENT')
                                "
                                >APP首页动态配置</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/portal/listConf"-->
                            <!--                v-if="-->
                            <!--                  rightsContains('LIST_GAINS_BLANK') ||-->
                            <!--                  rightsContains('LIST_POPULAR')-->
                            <!--                "-->
                            <!--                >榜单配置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/trade/plate/plateManage"-->
                            <!--                v-if="rightsContains('PLATE_MANAGE')"-->
                            <!--                >板块管理</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/focus/plateManage"-->
                            <!--                v-if="rightsContains('FOCUS')"-->
                            <!--                >Focus管理</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/product/category"-->
                            <!--                v-if="rightsContains('APP_PRODUCT_CATEGORY')"-->
                            <!--                >APP产品类型配置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/product/selection"-->
                            <!--                v-if="rightsContains('APP_PRODUCT_SELECTION')"-->
                            <!--                >APP产品精选配置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/product/recommend"-->
                            <!--                v-if="rightsContains('APP_PRODUCT_RECOMMEND')"-->
                            <!--                >APP产品推荐配置</el-menu-item-->
                            <!--              >-->

                            <!--              <el-menu-item-->
                            <!--                index="/home/community"-->
                            <!--                v-if="rightsContains('COMMUNITY_MANAGEMENT')"-->
                            <!--                >社区信息管理</el-menu-item-->
                            <!--              >-->
                        </el-submenu>

                        <el-submenu
                            index="market"
                            v-if="
                                rightsContains('SMS_EMAIL_SEND_RECORD') ||
                                rightsContains('SYSTEM_NEWS_SETTING') ||
                                rightsContains('SYSTEM_PUSH_SETTING') ||
                                rightsContains('EMAIL_SEND') ||
                                rightsContains('COUPON_MANAGE') ||
                                rightsContains('COMMUNITY_VOTE_PROJECT') ||
                                rightsContains('ACTIVITY_MANAGE') ||
                                rightsContains('ACTIVITY_CONTRACT') ||
                                rightsContains('EMAIL_BATCH_SEND') ||
                                rightsContains('RED_ENVELOPE') ||
                                rightsContains('HASHRATE_MANAGEMENT') ||
                                rightsContains('ARENA_MANAGEMENT') ||
                                rightsContains('COIN_REBASE') ||
                                rightsContains('PURCHAE_ADMIN') ||
                                rightsContains('INCUBATOR_ADMIN') ||
                                rightsContains('PURCHAE_ADMIN') ||
                                rightsContains('ZOO_DIVIDE')
                            "
                        >
                            <template slot="title">
                                <i class="el-icon-news"></i>
                                <span slot="title">营销系统</span>
                            </template>
                            <!--              <el-menu-item-->
                            <!--                index="/home/hashrate/match-conf"-->
                            <!--                v-if="rightsContains('HASHRATE_MANAGEMENT')"-->
                            <!--                >算力挖矿奖励</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                v-if="rightsContains('SMS_EMAIL_SEND_RECORD')"
                                index="/home/hashrate/verification"
                                >验证码记录</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/coin/rebase"-->
                            <!--                v-if="rightsContains('COIN_REBASE')"-->
                            <!--                >币种变基</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/setting/news"-->
                            <!--                v-if="rightsContains('SYSTEM_NEWS_SETTING')"-->
                            <!--                >快讯设置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/setting/push"-->
                            <!--                v-if="rightsContains('SYSTEM_PUSH_SETTING')"-->
                            <!--                >推送设置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/email"-->
                            <!--                v-if="rightsContains('EMAIL_SEND')"-->
                            <!--                >发送邮件</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/home/batch/email"
                                v-if="rightsContains('EMAIL_BATCH_SEND')"
                                >批量发送邮件</el-menu-item
                            >

<!--                            <el-menu-item
                                index="/home/user/BindEmailUser/emailUser"
                                v-if="rightsContains('EMAIL_USER')"
                                >邮箱管理</el-menu-item
                            >-->

                            <!--              <el-menu-item-->
                            <!--                index="/home/coupon/management"-->
                            <!--                v-if="rightsContains('COUPON_MANAGE')"-->
                            <!--                >卡券管理</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/votingStrategy/projects"-->
                            <!--                v-if="rightsContains('COMMUNITY_VOTE_PROJECT')"-->
                            <!--                >社区投票</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/doubleEleven"-->
                            <!--                v-if="rightsContains('ACTIVITY_MANAGE')"-->
                            <!--                >双十一</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/nft"-->
                            <!--                v-if="rightsContains('BLIND_BOX_COIN')"-->
                            <!--                >NFT管理</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                  index="/home/withdrawNft"-->
                            <!--                  v-if="rightsContains('BLIND_BOX_COIN_WITHDRAWAL')"-->
                            <!--              >NFT提现管理</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/magicBox"-->
                            <!--                v-if="rightsContains('BLIND_BOX')"-->
                            <!--                >盲盒管理</el-menu-item-->
                            <!--              >-->
                            <!--              <el-submenu-->
                            <!--                index="/home/contract/activity"-->
                            <!--                v-if="rightsContains('ACTIVITY_CONTRACT')"-->
                            <!--              >-->
                            <!--                <template slot="title">-->
                            <!--                  <span slot="title">合约争霸</span>-->
                            <!--                </template>-->
                            <!--                <el-menu-item index="/home/contract/activity/match-conf"-->
                            <!--                  >比赛配置详情</el-menu-item-->
                            <!--                >-->
                            <!--                <el-menu-item index="/home/contract/activity/audit"-->
                            <!--                  >队长招募审核</el-menu-item-->
                            <!--                >-->
                            <!--              </el-submenu>-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/quiz/projects"-->
                            <!--                v-if="rightsContains('GUESS_PROJECT')"-->
                            <!--                >竞猜</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/vote/batchSetting"-->
                            <!--                v-if="rightsContains('VOTE_BATCH_SETTING')"-->
                            <!--                >投票批次设置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/vote/coinSetting"-->
                            <!--                v-if="rightsContains('VOTE_COIN_TYPE_SETTING')"-->
                            <!--                >投票币种设置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/red/packet"-->
                            <!--                v-if="rightsContains('RED_ENVELOPE')"-->
                            <!--                >APP发红包</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/red/audit"-->
                            <!--                v-if="rightsContains('RED_ENVELOPE')"-->
                            <!--                >大额红包审核</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/red/record"-->
                            <!--                v-if="rightsContains('RED_ENVELOPE')"-->
                            <!--                >红包领取记录</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/arena"-->
                            <!--                v-if="rightsContains('ARENA_MANAGEMENT')"-->
                            <!--                >竞技场</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/purchase"-->
                            <!--                v-if="rightsContains('PURCHAE_ADMIN')"-->
                            <!--                >申购管理</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/bonus"-->
                            <!--                v-if="rightsContains('ZOO_DIVIDE')"-->
                            <!--                >动物分红记录</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/incubator/activity"-->
                            <!--                v-if="rightsContains('INCUBATOR_ADMIN')"-->
                            <!--                >活动管理</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/incubator/air"-->
                            <!--                v-if="rightsContains('INCUBATOR_AIRDROP_TRANSFER')"-->
                            <!--                >空投转账</el-menu-item-->
                            <!--              >-->
                        </el-submenu>

                        <!--cms菜单配置开始-->
                        <!--            <el-submenu-->
                        <!--              index="cms/manage"-->
                        <!--              v-if="-->
                        <!--                rightsContains('CMS_MANAGE_CONTENT') ||-->
                        <!--                rightsContains('CMS_MANAGE_REVIEW') ||-->
                        <!--                rightsContains('CMS_MANAGE_LABEL') ||-->
                        <!--                rightsContains('CMS_MANAGE_RECOMMEND') ||-->
                        <!--                rightsContains('CMS_MANAGE_COLUMN') ||-->
                        <!--                rightsContains('CMS_MANAGE_MESSAGE')-->
                        <!--              "-->
                        <!--            >-->
                        <!--              <template slot="title">-->
                        <!--                <i class="el-icon-menu"></i>-->
                        <!--                <span slot="title">CMS系统</span>-->
                        <!--              </template>-->

                        <!--              <el-submenu-->
                        <!--                index="/cms/manage/content"-->
                        <!--                v-if="-->
                        <!--                  rightsContains('CMS_MANAGE_CONTENT') ||-->
                        <!--                  rightsContains('CMS_MANAGE_CONTENT_SIMPLIFY')-->
                        <!--                "-->
                        <!--              >-->
                        <!--                <template slot="title">-->
                        <!--                  <span slot="title">内容管理</span>-->
                        <!--                </template>-->
                        <!--                <el-menu-item-->
                        <!--                  index="/cms/manage/content/news"-->
                        <!--                  v-if="rightsContains('CMS_MANAGE_CONTENT')"-->
                        <!--                  >快讯</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/cms/manage/content/article"-->
                        <!--                  v-if="rightsContains('CMS_MANAGE_CONTENT')"-->
                        <!--                  >文章</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/cms/manage/content/newsSimplify"-->
                        <!--                  v-if="rightsContains('CMS_MANAGE_CONTENT_SIMPLIFY')"-->
                        <!--                  >快讯(简化)</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item-->
                        <!--                  index="/cms/manage/content/articleSimplify"-->
                        <!--                  v-if="rightsContains('CMS_MANAGE_CONTENT_SIMPLIFY')"-->
                        <!--                  >文章(简化)</el-menu-item-->
                        <!--                >-->
                        <!--              </el-submenu>-->

                        <!--              <el-submenu-->
                        <!--                index="/cms/manage/review"-->
                        <!--                v-if="rightsContains('CMS_MANAGE_REVIEW')"-->
                        <!--              >-->
                        <!--                <template slot="title">-->
                        <!--                  <span slot="title">审核管理</span>-->
                        <!--                </template>-->
                        <!--                <el-menu-item index="/cms/manage/review/wait"-->
                        <!--                  >待审核</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item index="/cms/manage/review/allTask"-->
                        <!--                  >全部任务</el-menu-item-->
                        <!--                >-->
                        <!--              </el-submenu>-->

                        <!--              <el-submenu-->
                        <!--                index="/cms/manage/label"-->
                        <!--                v-if="rightsContains('CMS_MANAGE_LABEL')"-->
                        <!--              >-->
                        <!--                <template slot="title">-->
                        <!--                  <span slot="title">标签库</span>-->
                        <!--                </template>-->
                        <!--                <el-menu-item index="/cms/manage/label/product"-->
                        <!--                  >币种标签库</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item index="/cms/manage/label/character"-->
                        <!--                  >人物标签库</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item index="/cms/manage/label/mechanism"-->
                        <!--                  >机构标签库</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item index="/cms/manage/label/project"-->
                        <!--                  >项目标签库</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item index="/cms/manage/label/category"-->
                        <!--                  >类别标签库</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item index="/cms/manage/label/custom"-->
                        <!--                  >自定义标签库</el-menu-item-->
                        <!--                >-->
                        <!--              </el-submenu>-->

                        <!--              <el-submenu-->
                        <!--                index="/cms/manage/recommend"-->
                        <!--                v-if="rightsContains('CMS_MANAGE_RECOMMEND')"-->
                        <!--              >-->
                        <!--                <template slot="title">-->
                        <!--                  <span slot="title">推荐管理</span>-->
                        <!--                </template>-->
                        <!--                <el-menu-item index="/cms/manage/recommend/recommendPosition"-->
                        <!--                  >推荐位管理</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item index="/cms/manage/recommend/recommendItem"-->
                        <!--                  >web列表推荐</el-menu-item-->
                        <!--                >-->
                        <!--                <el-menu-item index="/cms/manage/recommend/relevantRecommend"-->
                        <!--                  >相关推荐</el-menu-item-->
                        <!--                >-->
                        <!--              </el-submenu>-->

                        <!--              <el-submenu-->
                        <!--                index="/cms/manage/column"-->
                        <!--                v-if="rightsContains('CMS_MANAGE_COLUMN')"-->
                        <!--              >-->
                        <!--                <template slot="title">-->
                        <!--                  <span slot="title">栏目管理</span>-->
                        <!--                </template>-->
                        <!--                <el-menu-item index="/cms/manage/column/preview"-->
                        <!--                  >栏目预览</el-menu-item-->
                        <!--                >-->
                        <!--              </el-submenu>-->

                        <!--              <el-submenu-->
                        <!--                index="/cms/manage/statistics"-->
                        <!--                v-if="rightsContains('CMS_MANAGE_STATISTICS')"-->
                        <!--              >-->
                        <!--                <template slot="title">-->
                        <!--                  <span slot="title">统计查询</span>-->
                        <!--                </template>-->
                        <!--                <el-menu-item index="/cms/manage/statistics/statisticsNews"-->
                        <!--                  >资讯统计</el-menu-item-->
                        <!--                >-->
                        <!--              </el-submenu>-->

                        <!--              <el-menu-item-->
                        <!--                index="/cms/manage/message"-->
                        <!--                v-if="rightsContains('CMS_MANAGE_MESSAGE')"-->
                        <!--                >币圈信息流</el-menu-item-->
                        <!--              >-->
                        <!--            </el-submenu>-->
                        <!--cms菜单配置结束-->

                        <!--策略供应商菜单配置开始-->
                        <!--            <el-submenu-->
                        <!--              index="home/strategy"-->
                        <!--              v-if="rightsContains('STRATEGY_MANAGE')"-->
                        <!--            >-->
                        <!--              <template slot="title">-->
                        <!--                <i class="el-icon-menu"></i>-->
                        <!--                <span slot="title">策略系统</span>-->
                        <!--              </template>-->

                        <!--              <el-menu-item index="/home/strategy/supplier"-->
                        <!--                >策略管理</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item index="/home/strategy/subManage"-->
                        <!--                >订阅管理</el-menu-item-->
                        <!--              >-->
                        <!--              <el-menu-item index="/home/strategy/subRecord"-->
                        <!--                >订阅记录</el-menu-item-->
                        <!--              >-->
                        <!--            </el-submenu>-->
                        <!--策略供应商菜单配置结束-->

                        <!--供应商菜单配置开始-->
                        <!--            <el-submenu-->
                        <!--              index="home/agent"-->
                        <!--              v-if="rightsContains('AGENT_MANAGEMENT')"-->
                        <!--            >-->
                        <!--              <template slot="title">-->
                        <!--                <i class="el-icon-menu"></i>-->
                        <!--                <span slot="title">代理商管理系统</span>-->
                        <!--              </template>-->

                        <!--              <el-menu-item-->
                        <!--                index="/home/agent/agentManage"-->
                        <!--                v-if="rightsContains('AGENT_MANAGEMENT')"-->
                        <!--                >代理商管理</el-menu-item-->
                        <!--              >-->
                        <!--            </el-submenu>-->
                        <!--供应商菜单配置结束-->

                        <el-submenu
                            index="system"
                            v-if="
                                rightsContains('APP_VERSION_SETTING') ||
                                rightsContains('SYSTEM_SITE_CONFIG') ||
                                rightsContains('SYSTEM_WALLET_SWITCH') ||
                                rightsContains('CANCEL_ORDER_SWITCH') ||
                                rightsContains('SYSTEM_WALLET_ACCOUNT_SETTING') ||
                                rightsContains('SYSTEM_PROCESSOR_SETTING') ||
                                rightsContains('AUTHORITY_SETTING') ||
                                rightsContains('SERVICE_CHARGE_SETTING')
                            "
                        >
                            <template slot="title">
                                <i class="el-icon-setting"></i>
                                <span slot="title">系统设置</span>
                            </template>
                            <el-menu-item
                                index="/home/app/update"
                                v-if="rightsContains('APP_VERSION_SETTING')"
                                >APP版本设置</el-menu-item
                            >
                            <el-menu-item
                                index="/home/setting/siteconf"
                                v-if="rightsContains('SYSTEM_SITE_CONFIG')"
                                >SITECONF</el-menu-item
                            >
                            <el-menu-item
                                index="/home/setting/walletSwitch"
                                v-if="
                                    rightsContains('SYSTEM_WALLET_SWITCH') ||
                                    rightsContains('CANCEL_ORDER_SWITCH') ||
                                    rightsContains('SERVICE_CHARGE_SETTING')
                                "
                                >钱包开关</el-menu-item
                            >
                            <el-menu-item
                                index="/home/setting/walletAccount"
                                v-if="rightsContains('SYSTEM_WALLET_ACCOUNT_SETTING')"
                                >钱包账户设置</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/setting/processorConfig"-->
                            <!--                v-if="rightsContains('SYSTEM_PROCESSOR_SETTING')"-->
                            <!--                >Processor设置</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/home/setting/petty/cash"
                                v-if="rightsContains('AUTHORITY_SETTING')"
                                >出纳金配置</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/transfer/cold/wallet"-->
                            <!--                v-if="rightsContains('TRANSFER_COLD_WALLET')"-->
                            <!--                >转冷查询与配置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/setting/addressManage"-->
                            <!--                v-if="rightsContains('ETH_RUSH_NONCE')"-->
                            <!--                >ETH地址nonce管理</el-menu-item-->
                            <!--              >-->
                        </el-submenu>
                        <el-submenu
                            index="dataCenter"
                            v-if="
                                rightsContains('DATA_CENTRE_BALANCE') ||
                                rightsContains('DATA_CENTRE_CURRENT') ||
                                rightsContains('DATA_CENTRE_TRADE_FEE') ||
                                rightsContains('DATA_CENTRE_CONTRACT') ||
                                rightsContains('DATA_CENTRE_TRIBE_PROFIT') ||
                                rightsContains('DATA_CENTRE_DEPOSIT_WITHDRAW') ||
                                rightsContains('DATA_CENTRE_PLEDGE') ||
                                rightsContains('DATA_CENTRE_USER') ||
                                rightsContains('DEPOSIT_WITHDRAW_VISUAL') ||
                                rightsContains('SWEEP_DATA') ||
                                rightsContains('REFUND_COIN') ||
                                rightsContains('BKK_DESTROY_RECORD') ||
                                rightsContains('DATA_CENTRE_STAKING') ||
                                rightsContains('DATA_TRADE_VOLUME') ||
                                rightsContains('DATA_CENTRE_LISTING_APPLY') ||
                                rightsContains('WALLET_RECONCILIATION')
                            "
                        >
                            <template slot="title">
                                <i class="el-icon-document"></i>
                                <span slot="title">数据中心</span>
                            </template>
                            <el-menu-item
                                index="/datacenter/balance"
                                v-if="rightsContains('DATA_CENTRE_BALANCE')"
                                >余额查询</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/datacenter/current"-->
                            <!--                v-if="rightsContains('DATA_CENTRE_CURRENT')"-->
                            <!--                >活期宝查询</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/datacenter/tradefee"
                                v-if="rightsContains('DATA_CENTRE_TRADE_FEE')"
                                >手续费查询</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/datacenter/contract"-->
                            <!--                v-if="rightsContains('DATA_CENTRE_CONTRACT')"-->
                            <!--                >合约查询</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/datacenter/tribeprofit"-->
                            <!--                v-if="rightsContains('DATA_CENTRE_TRIBE_PROFIT')"-->
                            <!--                >部落收益查询</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/datacenter/walletbill"
                                v-if="rightsContains('DATA_CENTRE_DEPOSIT_WITHDRAW')"
                                >充提统计查询</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/datacenter/pledge"-->
                            <!--                v-if="rightsContains('DATA_CENTRE_PLEDGE')"-->
                            <!--                >定期宝数据</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/datacenter/user"
                                v-if="rightsContains('DATA_CENTRE_USER')"
                                >用户数据</el-menu-item
                            >
                            <el-menu-item
                                index="/datacenter/dw/visual"
                                v-if="rightsContains('DEPOSIT_WITHDRAW_VISUAL')"
                                >充提时间可视化</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/home/sweep"-->
                            <!--                v-if="rightsContains('SWEEP_DATA')"-->
                            <!--                >扫币设置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/refund"-->
                            <!--                v-if="rightsContains('REFUND_COIN')"-->
                            <!--                >退币设置</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/home/bkk/destroy/record"-->
                            <!--                v-if="rightsContains('BKK_DESTROY_RECORD')"-->
                            <!--                >BKK销毁记录</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/datacenter/stakingData"-->
                            <!--                v-if="rightsContains('DATA_CENTRE_STAKING')"-->
                            <!--                >Staking数据</el-menu-item-->
                            <!--              >-->
                            <el-menu-item
                                index="/datacenter/tradeVoulmeData"
                                v-if="rightsContains('DATA_TRADE_VOLUME')"
                                >交易量数据</el-menu-item
                            >
                            <!--              <el-menu-item-->
                            <!--                index="/datacenter/listingApply"-->
                            <!--                v-if="rightsContains('DATA_CENTRE_LISTING_APPLY')"-->
                            <!--                >上币申请查询</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/datacenter/dwsummary"-->
                            <!--                v-if="rightsContains('WALLET_RECONCILIATION')"-->
                            <!--                >充提整体数据</el-menu-item-->
                            <!--              >-->
                            <!--              <el-menu-item-->
                            <!--                index="/datacenter/rechangeReturn"-->
                            <!--                v-if="rightsContains('DEPOSITE_REFUND_COIN')"-->
                            <!--                >充值退回</el-menu-item-->
                            <!--              >-->
                        </el-submenu>

                        <!--            <el-submenu-->
                        <!--              index="/dataAnalysis"-->
                        <!--              v-if="rightsContains('DATA_ANALYSIS_ASSET_STATISTICS')"-->
                        <!--            >-->
                        <!--              <template slot="title">-->
                        <!--                <i class="el-icon-document"></i>-->
                        <!--                <span slot="title">数据分析</span>-->
                        <!--              </template>-->

                        <!--            </el-submenu>-->

                        <el-menu-item
                            index="/home/user/right"
                            v-if="
                                rightsContains('AUTHORITY_SETTING') ||
                                rightsContains('AUTHORITY_QUERY')
                            "
                        >
                            <i class="el-icon-edit-outline"></i>
                            <span slot="title">权限设置</span>
                        </el-menu-item>
                    </el-menu>
                </el-aside>
                <el-main style="background-color: #f2ece2">
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import useTabber from 'tabber-component';
import { RIGHTS_TYPE } from './common/constant';

export default {
    name: 'HomePage',
    computed: {
        ...mapState(['userInfo', 'userRights']),
        isBlockedDate() {
            return !useTabber(8);
        },
    },
    methods: {
        ...mapActions(['logout', 'refreshAuthInfo']),
        rightsContains(r) {
            let rights = this.userRights.split(',') || [];
            return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
        },

        refreshAuth() {
            this.refreshAuthInfo();
        },
    },
};
</script>

<style lang="less" scoped>
.home-page {
    display: flex;
    height: 100%;
    background-color: #f5f7fa;
}
.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dcdfe6;
    background-color: #303133;
    .el-dropdown-link {
        color: #ffffff;
        cursor: pointer;
    }
}
.aside {
    background-color: #545c64;
    border-right: 1px solid #dcdfe6;
    .el-menu {
        border: 0;
    }
}
.link {
    color: #ffffff;
}

.link:hover {
    color: #409eff;
}

.el-dropdown-link:hover {
    color: #409eff;
}
</style>
